// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2qUvx","messages":"Chat_messages__-xZx5","dateDivider":"Chat_dateDivider__3tBl0"};